import { call, noop } from './function';
import { isProduction } from './varia';
import debug from 'debug';
export const getLogger = (namespace, level) => {
    var _a, _b;
    const [nsName, nsLevel] = namespace.split(':');
    const logLevel = ((_a = level !== null && level !== void 0 ? level : nsLevel) !== null && _a !== void 0 ? _a : 'debug').toLowerCase();
    const isEnabled = !isProduction ||
        ((_b = call(global.configGet, 'verboseLog', false)) !== null && _b !== void 0 ? _b : false) ||
        ['error', 'critical'].indexOf(logLevel) > -1;
    if (!isEnabled) {
        return noop;
    }
    const logger = debug(`app:${nsName}:${logLevel}`);
    return logger;
};
